import SectionHeading from "@/components/feature/SectionHeading";
import { aboutStats, testimonials } from "@/mocks/site";

export default function VoicesSection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-100 border-b border-background-200">
      <SectionHeading
        align="center"
        eyebrow="用户口碑"
        title="举报有回应，处理看得见"
        description="来自观众、主播与行业观察者的真实反馈，是我们持续优化核查流程的依据。"
      />

      <dl className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {aboutStats.map((stat) => (
          <div
            key={stat.label}
            className="bg-background-50 border border-background-200 rounded-lg p-5 text-center"
          >
            <dd className="font-heading text-2xl md:text-3xl font-bold text-primary-600">
              {stat.value}
              <span className="ml-1 text-sm font-medium text-foreground-500">{stat.note}</span>
            </dd>
            <dt className="mt-2 text-xs md:text-sm text-foreground-600">{stat.label}</dt>
          </div>
        ))}
      </dl>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
        {testimonials.map((item) => (
          <blockquote
            key={item.name}
            className="relative bg-background-50 border border-background-200 rounded-lg p-5 md:p-6"
          >
            <i className="ri-double-quotes-l text-2xl text-primary-300" aria-hidden="true"></i>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">{item.content}</p>
            <footer className="mt-4 pt-4 border-t border-background-200 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-800 font-heading font-bold">
                {item.name.slice(0, 1)}
              </span>
              <span>
                <span className="block text-sm font-medium text-foreground-950">{item.name}</span>
                <span className="block text-xs text-foreground-500">{item.role}</span>
              </span>
            </footer>
          </blockquote>
        ))}
      </div>
    </section>
  );
}